import REQUEST from '@helpers/http.service';

const rootPath = '/campaign';

export async function getAllCampaigns(accessToken, status) {
  try {
    const res = await REQUEST({
      method: 'GET',
      url: status ? `${rootPath}?status=${status}` : rootPath,
      accessToken,
    });
    return res.data;
  } catch (error) {
    return error;
  }
}

export async function deleteCampaigns(accessToken, id) {
  try {
    const res = await REQUEST({
      method: 'DELETE',
      url: `${rootPath}/${id}`,
      accessToken,
    });
    return res.data;
  } catch (error) {
    return error;
  }
}

export async function cloneCampaigns(accessToken, data) {
  try {
    const res = await REQUEST({
      method: 'POST',
      url: `${rootPath}/clone`,
      accessToken,
      data,
    });
    return res.data;
  } catch (error) {
    return error;
  }
}

/**
 * Name Campaign or complete Campaign Info
 */
export async function getCampaign(accessToken, id) {
  try {
    const res = await REQUEST({
      method: 'GET',
      url: `${rootPath}/${id}`,
      accessToken,
    });
    return res.data;
  } catch (error) {
    return error;
  }
}

export async function postCampaign(accessToken, data) {
  try {
    const res = await REQUEST({
      method: 'POST',
      url: `${rootPath}`,
      accessToken,
      data,
    });
    return res.data;
  } catch (error) {
    return error;
  }
}

export async function updateCampaign(accessToken, data, id) {
  try {
    const res = await REQUEST({
      method: 'PUT',
      url: `${rootPath}/update/${id}`,
      accessToken,
      data,
    });
    return res.data;
  } catch (error) {
    return error;
  }
}

// Api call to extend the campaign
export async function extendCampaign(accessToken, data, id) {
  try {
    const res = await REQUEST({
      method: 'PUT',
      url: `${rootPath}/extend/${id}`,
      accessToken,
      data,
    });
    return res.data;
  } catch (error) {
    return error;
  }
}

/**
 * Design Campaign Info
 */

export async function saveCampaignLogo(accessToken, data) {
  try {
    const res = await REQUEST({
      method: 'POST',
      url: `${rootPath}/image`,
      accessToken,
      data,
    });
    return res.data;
  } catch (error) {
    return error;
  }
}

export async function saveDesignCampaignData(accessToken, data, type) {
  try {
    const res = await REQUEST({
      method: 'POST',
      url: `${rootPath}/${type}/design`,
      accessToken,
      data,
    });
    return res.data;
  } catch (error) {
    return error;
  }
}

/**
 * Setup Campaign Info
 */

export async function saveCampaignSetupData(accessToken, data, type) {
  try {
    const res = await REQUEST({
      method: 'POST',
      url: `${rootPath}/${type}/setup`,
      accessToken,
      data,
    });
    return res.data;
  } catch (error) {
    return error;
  }
}

/**
 * Review Campaign Info
 */

export async function saveCampaignReviewData(accessToken, data, type) {
  try {
    const res = await REQUEST({
      method: 'POST',
      url: `${rootPath}/${type}/review`,
      accessToken,
      data,
    });
    return res.data;
  } catch (error) {
    return error;
  }
}

export async function changeCampStatus(accessToken, data) {
  try {
    const res = await REQUEST({
      method: 'POST',
      url: `${rootPath}/change-status`,
      accessToken,
      data,
    });
    return res.data;
  } catch (error) {
    return error;
  }
}

export async function getDashboardCampaign(accessToken, id = '', hardRefresh = false) {
  let url = '';

  if (id) {
    if (hardRefresh) {
      url = `/dashboard/${id}?hardRefresh=${hardRefresh}`;
    } else {
      url = `/dashboard/${id}`;
    }
  } else if (hardRefresh) {
    url = `/dashboard?hardRefresh=${hardRefresh}`;
  } else {
    url = `/dashboard`;
  }

  try {
    const res = await REQUEST({
      method: 'GET',
      url,
      accessToken,
    });
    return res.data;
  } catch (error) {
    return error;
  }
}

export async function getUserParticipationStats(
  accessToken,
  campaignId = '',
  startDate = null,
  endDate = null,
) {
  let url = `/v2/analytics/user-participation`;
  if (campaignId && startDate && endDate) {
    url = `${url}/${campaignId}?startDate=${startDate}&endDate=${endDate}`;
  } else if (campaignId) {
    url = `${url}/${campaignId}`;
  }

  try {
    const res = await REQUEST({
      method: 'GET',
      url,
      accessToken,
    });
    return res.data;
  } catch (error) {
    return error;
  }
}

// Api to get campaign analytics based filter
export async function getCampaignAnalyticsByFilter(accessToken, campaignId, startDate, endDate) {
  let url = `/v2/analytics/filter/${campaignId}`;
  if (startDate && endDate) {
    url += `?startDate=${startDate}&endDate=${endDate}`;
  }
  try {
    const res = await REQUEST({
      method: 'GET',
      url,
      accessToken,
    });
    return res.data;
  } catch (error) {
    return error;
  }
}

// Dc campaign apis

function normalizeError(error) {
  const message = error?.response?.data?.message || error?.message || 'Unexpected error';
  return { status: false, message };
}

export async function saveCampaignBasicInfo(accessToken, data) {
  try {
    const res = await REQUEST({
      method: 'POST',
      url: `${rootPath}/basic-info`,
      accessToken,
      data,
    });
    return res.data;
  } catch (error) {
    return normalizeError(error);
  }
}

export async function updateCampaignBasicInfo(accessToken, campaignId, data) {
  try {
    const res = await REQUEST({
      method: 'PUT',
      url: `${rootPath}/basic-info/${campaignId}`,
      accessToken,
      data,
    });
    return res.data;
  } catch (error) {
    return normalizeError(error);
  }
}

export async function saveOfferConfig(accessToken, campaignId, data) {
  try {
    const res = await REQUEST({
      method: 'POST',
      url: `${rootPath}/${campaignId}/offer`,
      accessToken,
      data,
    });
    return res.data;
  } catch (error) {
    return normalizeError(error);
  }
}

export async function saveTargetUserConfig(accessToken, campaignId, data) {
  try {
    const res = await REQUEST({
      method: 'POST',
      url: `${rootPath}/${campaignId}/config`,
      accessToken,
      data,
    });
    return res.data;
  } catch (error) {
    return normalizeError(error);
  }
}

export async function launchDC(accessToken, campaignId, data) {
  try {
    const res = await REQUEST({
      method: 'POST',
      url: `${rootPath}/${campaignId}/save`,
      accessToken,
      data,
    });
    return res.data;
  } catch (error) {
    return normalizeError(error);
  }
}

export async function getDcStats(accessToken, filter = {}) {
  // Default query parameters
  const defaultParams = {
    granularity: 'weekly',
  };

  // Merge default params with filter (filter values override defaults)
  const queryParams = { ...defaultParams, ...filter };

  // Add store and terminal parameters if they exist in the filter
  if (filter.stores && filter.stores.length > 0) {
    queryParams.stores = filter.stores.join(','); // Convert array to comma-separated string
  }

  if (filter.terminals && filter.terminals.length > 0) {
    queryParams.terminals = filter.terminals.join(','); // Convert array to comma-separated string
  }

  // Create the query string using the queryParams object
  const queryString = new URLSearchParams(queryParams).toString(); // Using URLSearchParams for easier query string formatting

  try {
    const res = await REQUEST({
      method: 'GET',
      url: `/transaction/dc/stats?${queryString}`,
      accessToken,
    });
    return res.data;
  } catch (error) {
    return error;
  }
}
